import React from "react";

import RecommendPresenter from "./recommendPresenter";

export default class extends React.Component {

  render() {
    return <RecommendPresenter />;
  }
}
